import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22layout.tsx%22,%22import%22:%22Funnel_Display%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22variable%22:%22--font-funnel%22,%22display%22:%22swap%22}],%22variableName%22:%22funnel%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Funnel Display', 'Funnel Display Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
